import { BvTableFieldArray } from 'bootstrap-vue';

import { formatAuditFieldChanges } from '@/common/FormattingUtils';
import Vue from 'vue';

export const feedTankAuditFields: BvTableFieldArray = [
	{ key: 'created_at', label: 'Date Sent' },
	{ key: 'from', label: 'From', formatter: formatAuditFieldChanges },
	{ key: 'to', label: 'To', formatter: formatAuditFieldChanges },
	{ key: 'user.name', label: 'By' },
];
